import React, { useContext } from 'react'
import { useParams, Redirect, useHistory } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import Card from '../../../components/Card'
import { Button } from '../../../components/Form'
import { api } from '../../../services/api'
import Spinner from '../../../components/Spinner'
import { GlobalContext } from '../../../contexts/GlobalContext'

export default function () {
	const history = useHistory()

	const { user } = useContext(GlobalContext)

	const { id } = useParams()

	const { data: modulo, isFetching } = useQuery({
		queryKey: ['get-module'],
		queryFn: async () => {
			const response = await api.get(`modulo/${id}`)

			return response
		}
	})

	function handleClick() {
		if (!user) {
			history.push({
				pathname: '/login',
				state: {
					modulo_id: id
				}
			})
		} else {
			history.push({
				pathname: '/dashboard',
				state: {
					modulo_id: id
				}
			})
		}
	}

	if (isFetching) {
		return (
			<Spinner />
		)
	}

	if (id === '1') {
		if(user) {
			return <Redirect 
				to={{
					pathname: '/auth/produtos/prontuario',
					state: { modulo_id: id }
				}}
			/>
		} else {
			return <Redirect to="/produtos/prontuario" />
		}
	}

	return (
		<div className="flex flex-col mx-36 my-8">
			<Card className="flex flex-col gap-6">
				<h1>{modulo.descricao}</h1>

				<Button onClick={handleClick} className="button white">
					Assinar agora
				</Button>
			</Card>
		</div>
	)
}
